<section class="header-default">
  <nav class="grid h-full w-full grid-cols-2 border-gray-200">
    <article class="col-span-1 my-auto ml-1 sm:ml-4">
      <a href="#" class="flex items-center">
        <img
          src="/assets/image/icon/logo-tsi-tres.png"
          class="mr-1 sm:mr-3 h-10 w-10 rounded-md"
          alt="TSI"
        />
        <h1
          class="self-center tracking-tight sm:tracking-normal whitespace-nowrap text-xl font-semibold dark:text-white"
        >
          SQL Report
          <span
            role="status"
            class="hidden sm:inline font-bold"
            [ngClass]="accentTextClass"
            >Dashboard</span
          >
        </h1>
      </a>
    </article>
    <article
      class="col-span-1 flex flex-row justify-end items-center gap-2 sm:px-2 lg:px-4 relative"
    >
      <button
        *ngIf="session"
        type="button"
        (click)="toggleMenu(); $event.stopPropagation()"
        title="Cuenta"
        class="flex items-center justify-center w-10 h-10 rounded-full text-white shadow-md ring-2 ring-white dark:ring-gray-800 transition-colors"
        [ngClass]="accentButtonClass"
      >
        <fa-icon [icon]="faUser"></fa-icon>
      </button>

      <div
        *ngIf="menuOpen() && session"
        class="absolute right-0 top-12 z-50 w-72 rounded-xl bg-white dark:bg-gray-800 shadow-2xl ring-1 ring-gray-200 dark:ring-gray-700 overflow-hidden"
        (click)="$event.stopPropagation()"
      >
        <div class="px-4 py-4 text-white" [ngClass]="accentHeaderGradientClass">
          <div class="flex items-center gap-3">
            <div class="flex items-center justify-center w-11 h-11 rounded-full bg-white/20 text-white text-base font-bold uppercase ring-2 ring-white/30">
              {{ (session.nombres || session.coduser || '?').charAt(0) }}
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold truncate">
                {{ session.nombres || session.coduser }}
              </p>
              <span
                *ngIf="userRoleLabel"
                class="inline-block mt-0.5 px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-white/20 text-white"
              >{{ userRoleLabel }}</span>
              <p class="text-xs truncate" [ngClass]="accentSubtleClass">
                {{ session.empresa || ('RUC ' + session.ruc) }}
              </p>
            </div>
          </div>
          <p
            *ngIf="session.empresa && session.ruc"
            class="mt-2 text-[11px] truncate"
            [ngClass]="accentSubtleMutedClass"
          >
            RUC {{ session.ruc }} · {{ session.coduser }}
          </p>
        </div>

        <div class="px-4 py-3 flex items-center justify-between border-b border-gray-100 dark:border-gray-700">
          <span class="text-sm text-gray-700 dark:text-gray-200 font-medium">
            Tema
          </span>
          <app-theme-switcher></app-theme-switcher>
        </div>

        <button
          type="button"
          (click)="logout()"
          class="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
        >
          <fa-icon [icon]="faLogout"></fa-icon>
          Cerrar sesión
        </button>
      </div>
    </article>
  </nav>
</section>
